/* Makes personalising the print obvious: a "Make it yours" card on the page (replacing the small tick box), a Personalise pill on the gallery preview (desktop only), and a Personalise section in the zoomed view's Options sheet (with its own text box). All of them drive the real Globo "Personalisation" tick box and "Text" field, so the form and the order data work exactly as before. Also keeps the zoomed photo visible in the strip above the Options sheet on phones, floats the Options sheet over the photo on desktop (the photo never resizes), hides the floating "See your preview" pill, loads the biggest artwork available (2000px; the files don't go higher, so asking for more changes nothing) instead of the 1400px / smaller one while the zoomed view is open, and adds a Size choice to the Options sheet for pages whose size is a plain drop-down (the homepage featured product). The preview image is a touch less bright than the older brightness setting gave (page preview 1.03 instead of 1.08, zoomed view 1.05 instead of 1.1; set here with !important so it wins over the older rule). On those pages it also keeps the preview's text style in step with the page's Text Style drop-down. With the on-page options it also hides the Compare print & frame options button (and its empty spacing) and styles the size selector, Text Style buttons and Mount choice as chips to match the finish chips (on the Custom Map Print page Text Style is a set of Globo swatch buttons rather than the homepage's own buttons, so those are styled as chips too). The grey info box under the chosen finish shows all four lines (Frame, Print protection, Delivery, Best for), one per row, like the compare lightbox did (the theme used to hide Frame and Best for and run the other two together). When a size change means the chosen finish isn't offered at the new size, the preview goes back to the default finish (without choosing it for the customer) and a note lists the finishes that aren't available at that size. On the homepage featured product it also stops the page jumping when a text style is picked (the theme briefly stacks copies of the option area while it rebuilds it), and no longer re-sends a change event for the text style (that raced the theme's rebuild and could flip the choice back). On the homepage featured product AND the Custom Map Print (any location) product page (product-info id ending __main-product-14966675210617; no other product page is touched) all the personalising fields (map location, text, custom colour, proof, same day dispatch, notes) sit in one box under a single button, so the form can be tucked away once it is filled in; the real fields stay in the form, so ticks, text and notes still go in the order. The box is OPEN when the page loads. While it is open the button reads "Personalise your print" with "Tap here to close once you've finished" under it (and an up arrow) so people know they can close it; when it is closed it reads "Click here to personalise" (or "Your personalisation" once something has been filled in) with the arrow pointing down. On those two pages the Bold / Thin / Squashed pill bar over the preview photo is hidden too (the Text Style buttons in the form do the same job and the preview follows them; on the product page the photo area sits outside the product-info element, so it is matched through the page instead); the Straight / Angled pills stay. Once something is filled in and the box is closed, the button itself shows what was entered (the map location and text, on one line) and, under it, the extras that are ticked (e.g. Proof Required, Same day dispatch + price, Notes added), so a customer can see what they've put in without opening the box; the count badge stays too. The text box also has a small line under it saying it replaces the text shown in the photos (on the product page the heading and the box are separate blocks, so the block just after the heading is the one tagged). The same day dispatch note is in the form twice (a small line under the tick box and a longer separate text block below it that starts with the same words); the separate copy is hidden so it only shows once. The form app (Globo) already refuses Add to cart while the finish, map location or text are empty, but its "This field is required" messages sat inside the folded box where nobody could see them and nothing pointed at the finish: now, when Add to cart is pressed and something still needs choosing or filling in, the page scrolls to that part and highlights it. A missing finish scrolls up to the finish chips, which get red borders and a red "Choose a finish to continue" line; a missing map location / text opens the personalise box (if it was closed), scrolls to it, says what to do on the button and puts the cursor in the first empty box (flagged boxes get a red border and a small red message). If more than one thing is missing it goes to the highest one on the page first (text style, then finish, then the personalise box). On normal map listings the Text Style chips (id fp-ts) start with nothing chosen, so when Add to cart is pressed without one chosen, the page scrolls up to them, they get red borders and a red "Choose a text style to continue" line (it goes away as soon as one is picked). The homepage featured product and the Custom Map Print page always have a text style chosen already, so they can't be missing one. Several other scripts (the older cart-prompt script, the form app, the browser's own focus handling) also scroll the page a moment after the click and used to pull it away again, so for a few seconds after Add to cart is pressed a small guard keeps easing the page onto the part that needs attention, and lets go the moment the customer scrolls, touches or types. The form app swallows the click event itself, so the guard listens for the press/release instead. The form app flips its own classes constantly, so the red flags are checked on a light 300ms timer rather than on every class change. On the two pages above the Add to cart button shows the live total (the price shown on the page, which already includes the finish and extras, times the quantity), e.g. "Add to cart · £94.00"; the button keeps its size. Those fields are styled to match the chips: rounded boxes (always with a visible, slightly darker border) with a pink focus, small bold headings, and the tick options as tappable chips, with tight spacing; the intro line at the top of the fields ("Please enter the text you would like..." / "Please provide your map location...") is semibold dark text like the other headings; the colour picker's swatch sits inside the box without covering the chosen colour code; the gaps around the button and above the quantity / Add to cart row are tightened too, with some breathing room above the personalise button and above and below that row. The form app pulls the group holding the button and fields 5px out on each side (to make up for padding on its own fields), which made the button and the opened fields wider than the chips above; that pull is cancelled so they line up. The product page's own stylesheet has an ID-based rule (#shopify-section-... .gpo-input) that outranks ordinary class selectors, so the box rules here start with body:not(#fpz), which always matches but counts as an ID, to win over it. NORMAL MAP LISTINGS (any product page with the optional "Personalise your print?" tick, i.e. the "Make it yours" card; body gets the class fpx-opt, NOT fp-opt, which the finish chips already use): the card stays the on/off switch, and once it is on the fields that appear (the text, proof, custom colour, same day dispatch, notes) get the same chip styling as the custom page, with the card itself showing what has been entered (the text on one line, and the extras that are ticked under it) and, when Add to cart is pressed with the text empty, saying what to fill in; the page scrolls to the card and puts the cursor in the empty box like on the other pages. These pages also get the Add to cart total on the button, the same spacing, and the Bold / Thin / Squashed bar over the photo hidden (body class fpx-nostyle, only when the page has its own Text Style buttons for the preview to follow). On these pages the Text Style choice also sits straight under the size and above the finish chips (like the Custom Map Print page): the form's own Text Style block can't be moved without the form app losing track of it, so a copy of it made of three chip buttons (id fp-ts) goes above the finish panel, and pressing one presses the real option; the form's own block is hidden. The gap between the finish chips and the Make it yours card is pulled in (-6px on the card's top margin) so it matches the gap between the card and the Add to cart row (about 32px each). PINCH TO ZOOM in the enlarged preview (touch screens): the enlarged view only had tap-to-zoom (and its touch-action: none stopped pinches). A two-finger pinch OUT on the picture now zooms in (like a tap, centred between the fingers) and a pinch IN while zoomed in zooms back out, and the pinch no longer counts as a swipe to the next picture or as a tap afterwards; while zoomed in, the page itself can no longer be pinch-zoomed by the browser (one-finger panning still works). */
(function () {
  if (window.__fpPers) return;
  window.__fpPers = 1;
  var PEN = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>';
  var CHEV = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';
  var xOpen = true, xNudge = false, xErrShown = false, fFinErr = false, fFlag = false, sErr = false, sFlag = false, guardId = 0, lastAdd = 0;
  var oVals = '', oExtras = '', oNudge = false;
  /* the homepage featured product and the Custom Map Print (any location) page */
  var FEAT = '[id$="__featured_personalise"],product-info[id$="__main-product-14966675210617"]';

  function box() { return document.querySelector('input[type="checkbox"][data-field-name="Personalisation"]'); }
  function label() {
    var c = box();
    return c && (document.querySelector('label[for="' + c.id + '"]') || c.closest('label'));
  }
  function isOn() { var c = box(); return !!(c && c.checked); }
  function headEl() {
    var els = document.querySelectorAll('.gpo-element'), i, h;
    for (i = 0; i < els.length; i++) {
      h = els[i].querySelector('.gpo-heading h4');
      if (h && /^personalise your print/i.test(h.textContent.trim())) return els[i];
    }
    return null;
  }
  function textEl() {
    var els = document.querySelectorAll('.gpo-element'), i;
    for (i = 0; i < els.length; i++) {
      if (/please enter the text you would like/i.test(els[i].textContent)) return els[i];
    }
    return null;
  }
  function field() {
    var t = textEl(), n = t && t.nextElementSibling, f;
    while (n) {
      f = n.querySelector('input[type="text"],textarea');
      if (f) return f;
      n = n.nextElementSibling;
    }
    return null;
  }
  function turnOn() { if (!isOn()) { var l = label(); l && l.click(); } }
  function turnOff() { if (isOn()) { var l = label(); l && l.click(); } }
  function toText(delay) {
    setTimeout(function () {
      var t = textEl();
      if (t && t.getClientRects().length) t.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, delay || 450);
  }
  function redraw() {
    var z = window.__fpzoom;
    z && z.redraw && z.redraw();
  }
  function sheetEnd() {
    var sh = document.querySelector('.fp-zsheet');
    if (sh) sh.scrollTop = sh.scrollHeight;
  }

  /* while the zoomed view is open, swap whatever size of artwork the preview is using (1400px, or smaller) for the 2000px one: the files don't go any higher than that, so it is the best quality there is */
  function hiRes() {
    if (!document.querySelector('.fp-zoom')) return;
    var x = window.__fpx, a = x && x.art && x.art();
    if (!a || !a.img || !(a.img instanceof HTMLImageElement) || a.__fpHi) return;
    var src = a.img.src || '', m = /[?&]width=(\d+)(?=&|$)/.exec(src);
    if (!m || parseInt(m[1], 10) >= 2000) return;
    a.__fpHi = 1;
    var hi = new Image();
    hi.onload = function () {
      if (hi.naturalWidth > a.img.naturalWidth) { a.img = hi; redraw(); }
    };
    hi.src = src.replace(/([?&])width=\d+(?=&|$)/, '$1width=2000');
  }

  function css() {
    if (document.getElementById('fp-pers-css')) return;
    var s = document.createElement('style');
    s.id = 'fp-pers-css';
    /* P('x') = the selector x inside the homepage featured product and inside the Custom Map Print (any location) page */
    var P = function (x) { return '[id$="__featured_personalise"] ' + x + ',product-info[id$="__main-product-14966675210617"] ' + x; };
    /* the Text Style swatch buttons on the Custom Map Print page (Globo swatches; the homepage has its own buttons, styled further down) */
    var TS = 'body:not(#fpz):has(.fp-in-panel) .swatch--gl:has(legend[data-name="Text Style"])';
    s.textContent =
      '.fp-seepill{display:none!important}' +
      '@media(max-width:899px){.fp-persbtn{display:none!important}}' +
      /* enlarged preview, zoomed in: one-finger panning only, so the browser does not pinch-zoom the whole page (the pinch is handled below) */
      '.fp-zoom[data-z=zoom] .fp-zoom-scroll{touch-action:pan-x pan-y!important}' +
      /* the preview image a touch less bright (the older rule had 1.08 on the page and 1.1 zoomed) */
      '.fp-in-view .fp-stage canvas{filter:brightness(1.03) saturate(1.04) contrast(1.01)!important}' +
      '.fp-zwrap .fp-zoom canvas{filter:brightness(1.05) saturate(1.06) contrast(1.02)!important}' +
      '.fp-na-note{margin:8px 0 0;font-size:13px;line-height:1.4;color:#666}' +
      /* no finish chosen when Add to cart is pressed: red line above the chips and red chip borders */
      '#fp-fin-msg{margin:0 0 8px;font-size:13px;line-height:1.3;font-weight:600;color:#d92d20}' +
      'body .fp-in-panel .fp-chips.fp-ferr .fp-opt:not(.is-selected){border-color:#d92d20!important;background:#fff7f6!important}' +
      /* no text style chosen when Add to cart is pressed (normal map listings): red line under the heading and red chip borders */
      '#fp-sty-msg{margin:0 0 8px;font-size:13px;line-height:1.3;font-weight:600;color:#d92d20}' +
      '#fp-ts.fp-serr .fp-ts-row button:not([aria-pressed=true]){border-color:#d92d20!important;background:#fff7f6!important}' +
      /* the grey info box under the chosen finish: all four lines (Frame, Print protection, Delivery, Best for), one per row, still grey (the theme hid lines 1 and 4 and ran 2 and 3 together) */
      'body .fp-in-panel .fp-info .fp-detail div,body .fp-in-panel .fp-info .fp-detail div:nth-child(1),body .fp-in-panel .fp-info .fp-detail div:nth-child(4){display:block!important;margin:0 0 3px!important;font-size:13px!important;line-height:1.4!important}' +
      'body .fp-in-panel .fp-info .fp-detail div:last-child{margin-bottom:0!important}' +
      'body .fp-in-panel .fp-info .fp-detail dt{font-weight:600;color:#555}' +
      'body .fp-in-panel .fp-info .fp-desc{margin:0 0 6px!important}' +
      /* the "click here to personalise" button and the folded-away fields */
      '.fp-xh,.fp-xdup{display:none!important}' +
      '#fp-xrow{box-sizing:border-box;width:100%;display:flex;align-items:center;gap:12px;margin:14px 0 0;padding:12px 14px;border:1.5px solid #ff0a89;border-radius:14px;background:#fff5fa;color:#111;font-family:inherit;text-align:left;cursor:pointer;scroll-margin-top:90px;transition:border-color .15s,background .15s}' +
      '#fp-xrow[aria-expanded=true]{background:#fff;margin-bottom:10px}' +
      '#fp-xrow .fp-xi{flex:none;width:36px;height:36px;border-radius:50%;background:#ffe6f2;color:#ff0a89;display:flex;align-items:center;justify-content:center}' +
      '#fp-xrow .fp-xt{flex:1;min-width:0}' +
      '#fp-xrow .fp-xt b{display:block;font-size:15px;line-height:1.25;font-weight:700;color:#111}' +
      '#fp-xrow .fp-xt span{display:block;font-size:13px;line-height:1.3;color:#555;margin-top:1px}' +
      '#fp-xrow[data-n="1"] .fp-xt span{color:#ff0a89;font-weight:600}' +
      /* what the customer has entered: shown on the button once something is filled in (the location and text on one line, cut with ... if long) */
      '#fp-xrow[data-f="1"] .fp-xt span.fp-xs{color:#111;font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
      '#fp-xrow .fp-xt span.fp-xe{color:#ff0a89;font-weight:600;font-size:12px;line-height:1.3;margin-top:2px}' +
      '#fp-xrow .fp-xt span.fp-xe:empty{display:none}' +
      '#fp-xrow .fp-xn{flex:none;border-radius:999px;background:#ff0a89;color:#fff;font-size:12px;font-weight:600;line-height:1;padding:5px 9px}' +
      '#fp-xrow .fp-xn[hidden]{display:none}' +
      '#fp-xrow .fp-xc{flex:none;display:flex;color:#ff0a89;transition:transform .2s}' +
      '#fp-xrow[aria-expanded=true] .fp-xc{transform:rotate(180deg)}' +
      /* the form app pulls the group that holds the button (or the Make it yours card) and the fields 5px out on each side (to make up for padding on its own fields, which these no longer have): cancel that so they line up with the chips above */
      'body:not(#fpz) .gpo-group__childs:has(#fp-xrow),body:not(#fpz) .gpo-group__childs:has(#fp-pers){margin-left:0!important;margin-right:0!important}' +
      /* tighter gaps around the personalise button: the form app's own spacing above it, and the picker's empty button area (nothing in it); but some breathing room above and below the quantity / Add to cart row, and the Add to cart text (with its price) never wraps so the button keeps its size */
      P('gpo-container') + '{margin-top:2px!important;margin-bottom:0!important}' +
      P('.gpo-group.gpo-form__group') + '{margin-top:0!important}' +
      P('.fp-cta-moved:has(.fp-go:empty)') + '{display:none!important}' +
      P('.product-form-wrapper') + '{margin-top:22px!important;margin-bottom:16px!important}' +
      P('button[name="add"] .btn-text>span') + '{white-space:nowrap}' +
      /* normal map listings (the optional Make it yours card): same spacing, Add to cart text never wraps, and no Bold / Thin / Squashed bar over the photo when the page has its own Text Style buttons */
      'body.fpx-opt product-info gpo-container{margin-top:2px!important;margin-bottom:0!important}' +
      'body.fpx-opt product-info .fp-cta-moved:has(.fp-go:empty){display:none!important}' +
      'body.fpx-opt product-info .product-form-wrapper{margin-top:22px!important;margin-bottom:16px!important}' +
      'body.fpx-opt product-info button[name="add"] .btn-text>span{white-space:nowrap}' +
      'body.fpx-opt .fp-pers{margin-top:-6px!important}' +
      'body.fpx-nostyle .fp-ctl .fp-pills[data-ctl="style"]{display:none!important}' +
      /* normal map listings: the Text Style chips that sit under the size, above the finish chips (they press the form's own Text Style option) */
      '#fp-ts{margin:16px 0 4px}' +
      '#fp-ts .fp-ts-h{display:flex;align-items:baseline;gap:6px;margin:0 0 7px;font-size:13px;line-height:1.3;color:#111}' +
      '#fp-ts .fp-ts-h b{font-weight:600;color:#111}' +
      '#fp-ts .fp-ts-h span{font-weight:400;color:#666}' +
      '#fp-ts .fp-ts-row{display:flex;flex-wrap:nowrap;gap:8px}' +
      '#fp-ts .fp-ts-row button{flex:1 1 0!important;min-width:0!important;box-sizing:border-box!important;margin:0!important;padding:13px 6px!important;border:1.5px solid #d3d6dc!important;border-radius:12px!important;background:#fff!important;color:#111!important;font-family:inherit!important;font-weight:600!important;font-size:15px!important;line-height:1.2!important;box-shadow:none!important;cursor:pointer;transition:border-color .15s,background .15s}' +
      '#fp-ts .fp-ts-row button[aria-pressed=true]{border-color:#ff0a89!important;background:#fff5fa!important;color:#ff0a89!important;box-shadow:inset 0 0 0 1px #ff0a89!important}' +
      /* the Bold / Thin / Squashed pill bar over the preview photo: not needed, the Text Style buttons in the form do the same job and the preview follows them (the Straight / Angled pills stay). On the product page the photo area is outside product-info, so it is matched through the page. */
      P('.fp-ctl .fp-pills[data-ctl="style"]') + ',body:has(product-info[id$="__main-product-14966675210617"]) .fp-ctl .fp-pills[data-ctl="style"]{display:none!important}' +
      /* the opened fields, styled like the chips: rounded boxes with a pink focus, small bold headings, tick options as tappable chips, tight spacing (selectors are heavier than the form app's own, and than the product page's ID-based rule, so its padding and borders don't come back) */
      'body:not(#fpz) .gpo-element.gpo-form__group.fp-xf{margin:0 0 8px!important;padding:0!important;outline:0!important;box-shadow:none!important}' +
      'body:not(#fpz) .gpo-element.gpo-form__group.fp-xf:has(.gpo-heading h5){margin-bottom:5px!important}' +
      'body:not(#fpz) .gpo-element.gpo-form__group.fp-xf.fp-xintro{margin-bottom:10px!important}' +
      'body:not(#fpz) .gpo-element.gpo-form__group.fp-xf:has(.gpo-heading h6){margin:-3px 0 8px!important}' +
      '.fp-xf .gpo-heading{margin:0!important;padding:0!important}' +
      '.fp-xf .gpo-heading h5{margin:0!important;font-family:inherit!important;font-size:13px!important;line-height:1.35!important;font-weight:600!important;color:#111!important}' +
      /* the intro line at the top of the fields: semibold dark, like the other headings */
      '.fp-xf.fp-xintro .gpo-heading h5{font-weight:600!important;color:#111!important}' +
      '.fp-xf .gpo-heading h6{margin:0!important;font-family:inherit!important;font-size:12px!important;line-height:1.4!important;font-weight:400!important;font-style:normal!important;color:#666!important}' +
      '.fp-xf>.gpo-label,.fp-xf>.gpo-label *{font-family:inherit!important}' +
      '.fp-xf>.gpo-label{display:block!important;margin:0 0 5px!important;padding:0!important;font-size:13px!important;line-height:1.35!important;font-weight:600!important;color:#111!important}' +
      '.fp-xf>.gpo-label .label-content{font-size:13px!important;font-weight:600!important;color:#111!important}' +
      '.fp-xf .gpo-input-wrap{margin:0!important;padding:0!important;border:0!important;border-radius:0!important;background:none!important;box-shadow:none!important;outline:0!important}' +
      '.fp-xf .gpo-input{box-sizing:border-box;width:100%;padding:13px 14px!important;border:1.5px solid #9aa1ac!important;border-radius:12px!important;background:#fff!important;color:#111;font-family:inherit!important;font-size:16px!important;line-height:1.3!important;box-shadow:none!important;outline:0;transition:border-color .15s}' +
      /* the form app switches the input border off again once something is typed (its "success" state), so the box border is set with a heavier selector to always stay */
      'body:not(#fpz) .gpo-element.gpo-form__group.fp-xf .gpo-input-wrap input.gpo-input,body:not(#fpz) .gpo-element.gpo-form__group.fp-xf .gpo-input-wrap textarea.gpo-input{box-sizing:border-box!important;padding:13px 14px!important;border:1.5px solid #9aa1ac!important;border-radius:12px!important;outline:0!important}' +
      'body:not(#fpz) .gpo-element.gpo-form__group.fp-xf .gpo-input-wrap .gpo-input:focus{border-color:#ff0a89!important;box-shadow:inset 0 0 0 1px #ff0a89!important;outline:0!important}' +
      /* a field the form app has flagged as required: red border and small red message under it (kept red even while the cursor is in it) */
      'body:not(#fpz) .gpo-element.gpo-form__group.fp-xf.has-error .gpo-input-wrap input.gpo-input,body:not(#fpz) .gpo-element.gpo-form__group.fp-xf.has-error .gpo-input-wrap textarea.gpo-input{border-color:#d92d20!important}' +
      'body:not(#fpz) .gpo-element.gpo-form__group.fp-xf.has-error .gpo-input-wrap .gpo-input:focus{border-color:#d92d20!important;box-shadow:inset 0 0 0 1px #d92d20!important}' +
      '.fp-xf .help-block.error{margin:4px 0 0!important;padding:0!important;font-size:12px!important;line-height:1.3!important;font-weight:600!important;color:#d92d20!important}' +
      /* small line under the text box: it replaces the words shown in the photos (the box wrapper wraps so the line drops underneath instead of sitting beside the box) */
      'body:not(#fpz) .gpo-element.gpo-form__group.fp-xtxt .gpo-input-wrap{display:flex!important;flex-wrap:wrap!important}' +
      'body:not(#fpz) .gpo-element.gpo-form__group.fp-xtxt .gpo-input-wrap .gpo-input{flex:0 0 100%!important}' +
      '.fp-xtxt .gpo-input-wrap::after{content:"This replaces the text shown in the photos.";display:block;flex:0 0 100%;box-sizing:border-box;margin:4px 0 0;font-size:12px;line-height:1.3;color:#666}' +
      '.fp-xf .gpo-input::placeholder{color:#8a8f98}' +
      '.fp-xf .gpo-textarea{min-height:84px;resize:vertical}' +
      /* colour picker: the colour swatch sits inside the box on the left and the colour code starts after it, so the swatch no longer covers the chosen colour; its instruction line is plain grey text */
      '.fp-xf .gpo-color-box{position:relative}' +
      'body:not(#fpz) .gpo-element.gpo-form__group.fp-xf .gpo-color-box .preview-btn{left:9px!important;top:50%!important;transform:translateY(-50%)!important;width:32px!important;height:32px!important;border-radius:8px!important;border:1.5px solid #9aa1ac!important;box-sizing:border-box!important}' +
      'body:not(#fpz) .gpo-element.gpo-form__group.fp-xf .gpo-color-box input.gpo-input{padding-left:66px!important}' +
      'body:not(#fpz) .gpo-element.gpo-form__group.fp-xf:has(.gpo-color-box)>.gpo-label,body:not(#fpz) .gpo-element.gpo-form__group.fp-xf:has(.gpo-color-box)>.gpo-label *{font-weight:400!important;color:#666!important}' +
      '.fp-xf .gpo-choicelist{position:relative;margin:0!important;padding:0!important}' +
      '.fp-xf .gpo-choicelist input[type=checkbox]{position:absolute!important;opacity:0!important;width:1px!important;height:1px!important;pointer-events:none}' +
      '.fp-xf .gpo-choicelist.gpo-checkbox>label{box-sizing:border-box;display:flex!important;align-items:center;flex-wrap:wrap;gap:2px 8px;width:100%;margin:0!important;padding:12px 14px!important;border:1.5px solid #9aa1ac;border-radius:12px;background:#fff;color:#111;font-family:inherit!important;font-size:15px;line-height:1.25;font-weight:600;cursor:pointer;transition:border-color .15s,background .15s}' +
      '.fp-xf .gpo-choicelist.gpo-checkbox>label *{font-family:inherit!important;font-size:15px!important;font-weight:600!important;line-height:1.25!important}' +
      '.fp-xf .gpo-choicelist.gpo-checkbox>label::before,.fp-xf .gpo-choicelist.gpo-checkbox>label::after{display:none!important}' +
      '.fp-xf .gpo-choicelist.gpo-checkbox>input:checked+label{border-color:#ff0a89;background:#fff5fa;color:#ff0a89;box-shadow:inset 0 0 0 1px #ff0a89}' +
      '.fp-xf .gpo-choicelist.gpo-checkbox>input:checked+label::after{display:block!important;content:"\\2713";margin-left:auto;font-weight:700}' +
      '.fp-xf .gpo-ov-wrapper{margin:0!important;padding:0!important}' +
      '.fp-xf .messages{margin:0!important;padding:0!important}' +
      /* Custom Map Print page: the Text Style swatch buttons as chips (rounded, pink when chosen, equal widths on one row) like the finish chips; the grey tooltip copy of each name is hidden */
      TS + ' legend{font-size:13px!important;font-weight:600!important;color:#111!important;margin:0 0 7px!important;padding:0!important}' +
      TS + ' legend .name-variant,' + TS + ' legend .name-variant *{font-weight:400!important;color:#666!important}' +
      TS + ' ul.value{display:flex!important;flex-wrap:nowrap!important;gap:8px!important;margin:0!important;padding:0!important;list-style:none!important}' +
      TS + ' li.select-option{flex:1 1 0!important;min-width:0!important;margin:0!important;padding:0!important}' +
      TS + ' li label.swatch-anchor{box-sizing:border-box!important;width:100%!important;height:auto!important;min-height:0!important;margin:0!important;display:flex!important;align-items:center!important;justify-content:center!important;text-align:center!important;padding:13px 6px!important;border:1.5px solid #d3d6dc!important;border-radius:12px!important;background:#fff!important;color:#111!important;font-family:inherit!important;font-weight:600!important;font-size:15px!important;line-height:1.2!important;box-shadow:none!important;cursor:pointer;transition:border-color .15s,background .15s}' +
      TS + ' li input:checked+label.swatch-anchor{border-color:#ff0a89!important;background:#fff5fa!important;color:#ff0a89!important;box-shadow:inset 0 0 0 1px #ff0a89!important}' +
      TS + ' .attr-title-hover{display:none!important}' +
      /* the theme rebuilds the option area when a text style is picked, briefly stacking extra copies above the old one (page jumps down then back): keep only the finished copy showing, and never show a copy that has not got its Text Style buttons yet while a finished one exists */
      'body:has(.fp-in-panel) product-info:has(variant-picker .mp-style-btns) variant-picker:not(:has(.mp-style-btns)),body:has(.fp-in-panel) product-info variant-picker:has(.mp-style-btns)~variant-picker:has(.mp-style-btns){position:absolute!important;visibility:hidden!important;height:0!important;overflow:hidden!important;margin:0!important;padding:0!important;pointer-events:none!important}' +
      /* on-page options: no Compare button (the empty wrapper left behind it had 34px of spacing); size selector, Text Style and Mount styled as chips like the finish chips */
      'body:has(.fp-in-panel) .fc-wrap,body:has(.fp-in-panel) .fc-help,body:has(.fp-in-panel) .fc-btn{display:none!important}' +
      'body .fp-in-panel .fp-seg{display:flex!important;align-items:stretch!important;gap:8px!important;padding:0!important;border-radius:0!important;background:none!important}' +
      'body .fp-in-panel .fp-segb{box-sizing:border-box;flex:1 1 0!important;min-width:0;height:auto!important;min-height:50px;display:flex!important;flex-direction:column!important;align-items:center!important;justify-content:center!important;gap:1px;text-align:center!important;padding:10px 8px!important;border:1.5px solid #d3d6dc!important;border-radius:12px!important;background:#fff!important;color:#111!important;font-size:15px;font-weight:600;line-height:1.2;box-shadow:none!important;transition:border-color .15s,background .15s}' +
      'body .fp-in-panel .fp-segb.is-selected,body .fp-in-panel .fp-segb[aria-pressed=true]{border-color:#ff0a89!important;background:#fff5fa!important;color:#ff0a89!important;box-shadow:inset 0 0 0 1px #ff0a89!important}' +
      'body .fp-in-panel .fp-segb small{display:block!important;margin:0!important;font-size:13px;line-height:1.2;white-space:nowrap}' +
      'body .fp-in-panel .fp-warn{border-radius:12px;padding:10px 14px;margin-top:8px}' +
      'body:has(.fp-in-panel) .gpo-ov-wrapper:has(input[name="Text Style"]){display:flex!important;flex-wrap:nowrap!important;gap:8px;width:100%;flex:0 0 100%}' +
      'body:has(.fp-in-panel) .gpo-ov-wrapper:has(input[name="Text Style"])>.gpo-swatches.buttons{flex:1 1 0;min-width:0;margin:0!important;padding:0!important;width:auto!important;display:block}' +
      'body:has(.fp-in-panel) .gpo-ov-wrapper:has(input[name="Text Style"]) .gpo-swatches.buttons>label{box-sizing:border-box;width:100%;margin:0!important;display:flex;align-items:center;justify-content:center;text-align:center;padding:13px 6px!important;border:1.5px solid #d3d6dc!important;border-radius:12px!important;background:#fff!important;color:#111!important;font-weight:600!important;font-size:15px;line-height:1.2;box-shadow:none;cursor:pointer;transition:border-color .15s,background .15s}' +
      'body:has(.fp-in-panel) .gpo-ov-wrapper:has(input[name="Text Style"]) .gpo-swatches.buttons>input:checked+label{border-color:#ff0a89!important;background:#fff5fa!important;color:#ff0a89!important;box-shadow:inset 0 0 0 1px #ff0a89}' +
      'body:has(.fp-in-panel) .gpo-ov-wrapper:has(input[name="Text Style"]) .gpo-ov-title,body:has(.fp-in-panel) .gpo-ov-wrapper:has(input[name="Text Style"]) .gpo-ov-title span{font-weight:600!important;color:inherit!important}' +
      'body:has(.fp-in-panel) .gpo-ov-wrapper:has(input[name="Text Style"]) .gpo-tooltip{display:none!important}' +
      /* Text Style heading: one line like the other headings, chosen value inline in grey */
      'body:has(.fp-in-panel) .gpo-element:has(input[name="Text Style"]){display:flex!important;flex-wrap:wrap;align-items:baseline;margin-top:14px!important}' +
      'body:has(.fp-in-panel) .gpo-element:has(input[name="Text Style"])>.gpo-label{flex:none;width:auto!important;margin:0 0 7px!important;padding:0!important;display:block!important;font-size:13px!important;font-weight:600!important;color:#111!important}' +
      'body:has(.fp-in-panel) .gpo-element:has(input[name="Text Style"])>.gpo-label .label-content{font-size:13px!important;font-weight:600!important;color:#111!important}' +
      'body:has(.fp-in-panel) .gpo-element:has(input[name="Text Style"])>.gpo-selected-values{flex:none;margin:0 0 7px 6px!important;padding:0!important;font-size:13px!important;font-weight:400!important;color:#666!important}' +
      'body:has(.fp-in-panel) .gpo-element:has(input[name="Text Style"])>.gpo-selected-values:empty{display:none}' +
      'body:has(.fp-in-panel) .mp-style-btns{display:flex!important;flex-wrap:nowrap;gap:8px;width:100%}' +
      'body:has(.fp-in-panel) .mp-style-btns button{flex:1 1 0;min-width:0;box-sizing:border-box;margin:0;padding:13px 6px;border:1.5px solid #d3d6dc;border-radius:12px;background:#fff;color:#111;font-family:inherit;font-weight:600;font-size:15px;line-height:1.2;box-shadow:none;cursor:pointer;transition:border-color .15s,background .15s}' +
      'body:has(.fp-in-panel) .mp-style-btns button.is-active,body:has(.fp-in-panel) .mp-style-btns button[aria-pressed=true]{border-color:#ff0a89;background:#fff5fa;color:#ff0a89;box-shadow:inset 0 0 0 1px #ff0a89}' +
      'body:has(.fp-in-panel) .globo-swatch-product-detail .dropdown-button-gsw{box-sizing:border-box;border:1.5px solid #ff0a89!important;border-radius:12px!important;background:#fff5fa!important;padding:13px 14px!important;min-height:0;font-weight:600;color:#111;box-shadow:inset 0 0 0 1px #ff0a89}' +
      'body:has(.fp-in-panel) .globo-swatch-product-detail .dropdown-button-gsw__value{font-weight:600;font-size:15px}' +
      'body:has(.fp-in-panel) .globo-swatch-product-detail .ul-globo-dropdown-option{border:1.5px solid #d3d6dc;border-radius:12px;overflow:hidden;box-shadow:0 8px 24px rgba(0,0,0,.12)}' +
      'body:has(.fp-in-panel) .globo-swatch-product-detail .name-option{font-weight:700}' +
      'body:has(.fp-in-panel) .product-form__input--dropdown select.select[name^="options[Select the size"]{box-sizing:border-box;border:1.5px solid #ff0a89!important;border-radius:12px!important;background-color:#fff5fa!important;padding-top:13px;padding-bottom:13px;font-weight:600;color:#111;box-shadow:inset 0 0 0 1px #ff0a89}' +
      'body:has(.fp-in-panel) .product-form__input--dropdown .form__label{font-weight:700}' +
      /* the Make it yours card (normal map listings): same width as the chips; shows what has been entered once it is on */
      '.fp-pers{box-sizing:border-box;width:100%;display:flex;align-items:center;gap:12px;margin:14px 0 10px;padding:14px;border:1.5px solid #d3d6dc;border-radius:14px;background:#fff;scroll-margin-top:90px;transition:border-color .15s,background .15s}' +
      '.fp-pers.on{border-color:#ff0a89;background:#fff5fa}' +
      '.fp-pers-ic{flex:none;width:40px;height:40px;border-radius:50%;background:#ffe6f2;color:#ff0a89;display:flex;align-items:center;justify-content:center}' +
      '.fp-pers-t{flex:1;min-width:0}' +
      '.fp-pers-t b{display:block;font-size:15px;line-height:1.25;font-weight:700;color:#111}' +
      '.fp-pers-t span{display:block;font-size:13px;line-height:1.35;color:#555;margin-top:2px}' +
      '.fp-pers[data-n="1"] .fp-pers-t span.fp-pers-s{color:#ff0a89;font-weight:600}' +
      '.fp-pers[data-f="1"] .fp-pers-t span.fp-pers-s{color:#111;font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
      '.fp-pers-t span.fp-pers-x{color:#ff0a89;font-weight:600;font-size:12px;line-height:1.3;margin-top:2px}' +
      '.fp-pers-t span.fp-pers-x:empty{display:none}' +
      '.fp-pers-b{flex:none;border:0;border-radius:999px;background:#ff0a89;color:#fff;font-family:inherit;font-size:14px;font-weight:600;line-height:1;padding:12px 16px;cursor:pointer}' +
      '.fp-pers.on .fp-pers-b{background:#fff;color:#ff0a89;box-shadow:0 0 0 1.5px #ff0a89 inset}' +
      '.fp-persbtn{position:absolute;left:10px;top:10px;z-index:5;display:flex;align-items:center;gap:6px;border:0;border-radius:999px;background:rgba(255,255,255,.94);color:#ff0a89;font-family:inherit;font-size:13px;font-weight:600;line-height:1;padding:10px 14px;cursor:pointer;box-shadow:0 1px 6px rgba(0,0,0,.18)}' +
      '.fp-persbtn svg{flex:none}' +
      '.fp-backpill:not([hidden])~.fp-persbtn{top:52px}' +
      '.fp-zpers{margin-top:2px}.fp-zpers .fp-zpbtn{display:flex;align-items:center;justify-content:center;gap:6px;width:100%;color:#ff0a89;font-weight:600}.fp-zpers .fp-zpbtn[aria-pressed=true]{color:#fff}' +
      '.fp-zptxt{margin-top:10px}.fp-zptxt[hidden]{display:none}' +
      '.fp-zpin{box-sizing:border-box;width:100%;padding:13px 14px;border:1.5px solid #d3d6dc;border-radius:12px;background:#fff;color:#111;font-family:inherit;font-size:16px;line-height:1.2}' +
      '.fp-zpin:focus{outline:0;border-color:#ff0a89;box-shadow:0 0 0 1px #ff0a89 inset}' +
      '.fp-zns{box-sizing:border-box;width:100%;padding:13px 14px;border:1.5px solid #ff0a89;border-radius:12px;background:#fff;color:#111;font-family:inherit;font-size:16px;font-weight:600;line-height:1.2}' +
      '.fp-zplinks{display:flex;justify-content:space-between;gap:12px;margin-top:6px}' +
      '.fp-zplinks button{border:0;background:none;padding:8px 0;font-family:inherit;font-size:13px;line-height:1.2;color:#555;text-decoration:underline;cursor:pointer}' +
      '.fp-zsheet .fp-zdone{position:sticky;bottom:0}' +
      /* desktop: the Options sheet is a floating card over the photo; the photo keeps its full size */
      '@media(min-width:900px){' +
      '.fp-zoom .fp-zoom-scroll{top:0;bottom:0}' +
      '.fp-zbg{display:none}' +
      '.fp-zsheet{left:auto;right:16px;top:68px;bottom:auto;width:360px;max-height:calc(100% - 92px);border-radius:16px;box-shadow:0 12px 44px rgba(0,0,0,.28)}' +
      '.fp-zsheet .fp-pill{cursor:pointer}' +
      '.fp-zsheet .fp-zdone{border-radius:999px}' +
      '}';
    document.head.appendChild(s);
  }

  /* normal map listings: what the Make it yours card says. The fields that appear after the tick (from the "Please enter the text..." line down to Your Notes) get the chip styling, and what has been entered (the text, and the extras that are ticked) is worked out here for the card to show. A field the form app has flagged as required (Add to cart pressed with the text empty) turns the card's line into a nudge. */
  function syncOpt() {
    var c = box(), card = document.getElementById('fp-pers'), t = c && textEl();
    if (!c || !card || !t || document.querySelector(FEAT)) { oVals = ''; oExtras = ''; oNudge = false; return; }
    var list = [], n = t, i, j, cb, ins, ta, lab, nm, v, h6, hk, dup;
    var vals = [], extras = [], hs = [], bad = false;
    while (n) {
      if (n.classList && n.classList.contains('gpo-element')) list.push(n);
      n = n.nextElementSibling;
    }
    for (i = 0; i < list.length; i++) {
      ta = list[i].querySelectorAll('.gpo-ov-helptext');
      for (j = 0; j < ta.length; j++) { v = norm(ta[j].textContent).slice(0, 40); if (v.length >= 20) hs.push(v); }
    }
    for (i = 0; i < list.length; i++) {
      if (list[i].classList.contains('has-error')) bad = true;
      cb = list[i].querySelectorAll('input[type="checkbox"]');
      for (j = 0; j < cb.length; j++) {
        if (!cb[j].checked) continue;
        lab = (cb[j].id && document.querySelector('label[for="' + cb[j].id + '"]')) || cb[j].closest('label');
        nm = lab ? lab.textContent.replace(/\s+/g, ' ').replace(/\s*\(order by[^)]*\)/i, '').replace(/\s*\(/, ' (').trim() : '';
        if (nm) extras.push(nm);
      }
      ins = list[i].querySelectorAll('input[type="text"]:not(.gpo-color)');
      for (j = 0; j < ins.length; j++) {
        v = ins[j].value.trim();
        if (v) vals.push(v);
      }
      ta = list[i].querySelectorAll('textarea');
      for (j = 0; j < ta.length; j++) {
        if (ta[j].value.trim()) extras.push('Notes added');
      }
      h6 = list[i].querySelector('.gpo-heading h6');
      hk = h6 ? norm(h6.textContent).slice(0, 40) : '';
      dup = !!(h6 && hk.length >= 20 && !list[i].querySelector('input,textarea,select') && hs.indexOf(hk) > -1);
      list[i].classList.toggle('fp-xdup', dup);
      list[i].classList.add('fp-xf');
      list[i].classList.toggle('fp-xintro', i === 0);
    }
    oVals = vals.join(' · ');
    oExtras = extras.join(' · ');
    oNudge = bad;
  }

  function syncCard() {
    var h = headEl(), c = box();
    if (!h || !c) return;
    css();
    var card = document.getElementById('fp-pers');
    if (!card) {
      card = document.createElement('div');
      card.id = 'fp-pers';
      card.className = 'fp-pers';
      card.innerHTML = '<span class="fp-pers-ic">' + PEN + '</span><div class="fp-pers-t"><b></b><span class="fp-pers-s"></span><span class="fp-pers-x"></span></div><button type="button" class="fp-pers-b"></button>';
      h.parentNode.insertBefore(card, h);
      card.querySelector('button').addEventListener('click', function () {
        if (isOn()) { turnOff(); } else { turnOn(); toText(450); }
        setTimeout(syncAll, 60);
      });
    } else if (card.nextElementSibling !== h && card.parentNode !== h.parentNode) {
      h.parentNode.insertBefore(card, h);
    }
    h.classList.add('fp-vh');
    var ce = c.closest('.gpo-element');
    ce && ce.classList.add('fp-vh');
    var on = isOn();
    card.classList.toggle('on', on);
    var t = card.querySelector('b'), d = card.querySelector('.fp-pers-s'), x = card.querySelector('.fp-pers-x'), b = card.querySelector('button');
    var filled = on && !oNudge && !!oVals;
    var tt = on ? 'Personalising' : 'Make it yours',
      dd = on ? (oNudge ? 'Fill in the box marked below, then add to cart' : (oVals || 'Add your own words in the boxes below')) : 'Swap the words on the map for your own',
      xx = on && !oNudge ? oExtras : '',
      bb = on ? 'Remove' : 'Personalise';
    if (t.textContent !== tt) t.textContent = tt;
    if (d.textContent !== dd) d.textContent = dd;
    if (x.textContent !== xx) x.textContent = xx;
    if (b.textContent !== bb) b.textContent = bb;
    if (oNudge && on) card.setAttribute('data-n', '1'); else card.removeAttribute('data-n');
    if (filled) card.setAttribute('data-f', '1'); else card.removeAttribute('data-f');
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
  }

  function syncPill() {
    var v = document.querySelector('.fp-in-view');
    if (!v || !box()) return;
    css();
    var p = v.querySelector('.fp-persbtn');
    if (!p) {
      p = document.createElement('button');
      p.type = 'button';
      p.className = 'fp-persbtn';
      v.appendChild(p);
      p.addEventListener('click', function (e) {
        e.stopPropagation();
        turnOn();
        toText(450);
        setTimeout(syncAll, 60);
      });
    }
    var txt = isOn() ? 'Edit your text' : 'Personalise';
    if (p.getAttribute('data-t') !== txt) {
      p.setAttribute('data-t', txt);
      p.innerHTML = PEN + '<span>' + txt + '</span>';
    }
  }

  function fire(el, type) {
    try { el.dispatchEvent(new Event(type, { bubbles: true })); } catch (err) { /* ignore */ }
  }

  function norm(t) { return String(t || '').replace(/\s+/g, ' ').trim().toLowerCase(); }

  /* body classes: fpx-opt on normal map listings (the optional Make it yours card; not fp-opt, that is the finish chips' own class), fpx-nostyle there when the page has its own Text Style buttons for the preview to follow */
  function syncBody() {
    var opt = !!(box() && document.getElementById('fp-pers') && !document.querySelector(FEAT) && document.querySelector('.fp-in-panel'));
    var hasStyle = !!document.querySelector('.gpo-element input[name="Text Style"],product-info select[name="options[Text Style]"],.swatch--gl legend[data-name="Text Style"]');
    document.body.classList.toggle('fpx-opt', opt);
    document.body.classList.toggle('fpx-nostyle', opt && hasStyle);
  }

  /* normal map listings: Text Style chips straight under the size, above the finish chips. The form's own Text Style block lives inside the form app's markup (moving it would lose it when the form app redraws), so this is a copy made of chip buttons that sits above the finish panel; pressing one presses the real option, and the form's own block is hidden. */
  function pickStyle(v) {
    var rs = document.querySelectorAll('.gpo-element input[type="radio"][name="Text Style"]'), i, r = null, l;
    for (i = 0; i < rs.length; i++) { if (rs[i].value === v) { r = rs[i]; break; } }
    if (!r) return;
    l = (r.id && document.querySelector('label[for="' + r.id + '"]')) || r.closest('label');
    if (l) l.click();
    if (!r.checked) {
      r.checked = true;
      fire(r, 'input');
      fire(r, 'change');
    }
    setTimeout(syncAll, 60);
  }
  function syncTS() {
    var ex = document.getElementById('fp-ts'), panel = document.querySelector('.fp-in-panel'), rs = [], ts = null, i, b, row, cur = '';
    if (document.body.classList.contains('fpx-opt') && panel) {
      rs = document.querySelectorAll('.gpo-element input[type="radio"][name="Text Style"]');
      ts = rs.length ? rs[0].closest('.gpo-element') : null;
    }
    if (!ts) { ex && ex.parentNode.removeChild(ex); return; }
    css();
    var key = Array.prototype.map.call(rs, function (r) { return r.value; }).join('|');
    if (!ex) {
      ex = document.createElement('div');
      ex.id = 'fp-ts';
      ex.innerHTML = '<p class="fp-ts-h"><b>Text Style</b><span></span></p><div class="fp-ts-row"></div>';
      ex.querySelector('.fp-ts-row').addEventListener('click', function (e) {
        var bt = e.target && e.target.closest && e.target.closest('button[data-v]');
        if (bt) pickStyle(bt.getAttribute('data-v'));
      });
    }
    row = ex.querySelector('.fp-ts-row');
    if (ex.getAttribute('data-k') !== key) {
      ex.setAttribute('data-k', key);
      row.innerHTML = '';
      Array.prototype.forEach.call(rs, function (r) {
        b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('data-v', r.value);
        b.textContent = r.value;
        row.appendChild(b);
      });
    }
    if (ex.nextElementSibling !== panel || ex.parentNode !== panel.parentNode) panel.parentNode.insertBefore(ex, panel);
    for (i = 0; i < rs.length; i++) { if (rs[i].checked) cur = rs[i].value; }
    Array.prototype.forEach.call(row.children, function (bt) {
      var on = bt.getAttribute('data-v') === cur;
      bt.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var sp = ex.querySelector('.fp-ts-h span');
    if (sp.textContent !== cur) sp.textContent = cur;
    ts.classList.add('fp-vh');
  }

  /* normal map listings: the text style counts as missing when the form has Text Style options and none is chosen. Once Add to cart has been pressed (the form app flags it, or the click guard below sets sFlag) and it is still missing, the chips get red borders and a red "Choose a text style to continue" line goes under the heading. It goes away by itself once one is chosen. */
  function styleMissing() {
    var rs = document.querySelectorAll('.gpo-element input[type="radio"][name="Text Style"]'), i;
    if (!rs.length) return false;
    for (i = 0; i < rs.length; i++) { if (rs[i].checked) return false; }
    return true;
  }
  function syncStyleErr() {
    var ex = document.getElementById('fp-ts');
    if (!ex) { sErr = false; sFlag = false; return; }
    var els = document.querySelectorAll('.gpo-element.has-error'), bad = false, i;
    for (i = 0; i < els.length; i++) {
      if (els[i].querySelector('input[name="Text Style"]')) { bad = true; break; }
    }
    var miss = styleMissing();
    if (!miss) sFlag = false; else if (bad) sFlag = true;
    var msg = document.getElementById('fp-sty-msg');
    if (!(miss && sFlag)) {
      sErr = false;
      ex.classList.remove('fp-serr');
      msg && msg.parentNode.removeChild(msg);
      return;
    }
    css();
    if (!msg) {
      msg = document.createElement('p');
      msg.id = 'fp-sty-msg';
      msg.setAttribute('role', 'alert');
      msg.textContent = 'Choose a text style to continue';
    }
    var row = ex.querySelector('.fp-ts-row');
    if (msg.nextElementSibling !== row) ex.insertBefore(msg, row);
    ex.classList.add('fp-serr');
    sErr = true;
  }

  /* any page with the finish chips: the finish counts as missing when the (visible) Print Finish drop-down is empty. Once Add to cart has been pressed (the form app flags it, or the click guard below sets fFlag) and it is still missing, the chips get red borders and a red "Choose a finish to continue" line goes above them. It goes away by itself once a finish is chosen. The scrolling to it is done by the click guard further down. */
  function finMissing() {
    var s = finishSel();
    return !!(s && !s.value);
  }
  function syncFinish() {
    var ch = document.querySelector('.fp-in-panel .fp-chips');
    if (!ch) return;
    var els = document.querySelectorAll('.gpo-element.has-error'), globoBad = false, i, s;
    for (i = 0; i < els.length; i++) {
      s = els[i].querySelector('select');
      if (s && /print finish/i.test(s.name || '')) { globoBad = true; break; }
    }
    var miss = finMissing();
    if (!miss) fFlag = false; else if (globoBad) fFlag = true;
    var msg = document.getElementById('fp-fin-msg');
    if (!(miss && fFlag)) {
      fFinErr = false;
      ch.classList.remove('fp-ferr');
      msg && msg.parentNode.removeChild(msg);
      return;
    }
    css();
    if (!msg) {
      msg = document.createElement('p');
      msg.id = 'fp-fin-msg';
      msg.setAttribute('role', 'alert');
      msg.textContent = 'Choose a finish to continue';
    }
    if (msg.nextElementSibling !== ch) ch.parentNode.insertBefore(msg, ch);
    ch.classList.add('fp-ferr');
    fFinErr = true;
  }

  /* Add to cart pressed: for a few seconds, keep the page eased onto the part that needs choosing or filling in (the text style first, then the finish, then the personalise box). The older cart-prompt script, the form app and the browser's focus handling all scroll the page a moment after the click and used to pull it away again. Lets go at once if the customer scrolls, touches, clicks or types, and after 2.5 seconds on target. Nothing happens when nothing is missing. */
  function startGuard() {
    var id = ++guardId, t0 = Date.now(), lockedAt = 0, focused = false;
    var evs = ['wheel', 'touchstart', 'mousedown', 'keydown'];
    function stop() {
      guardId++;
      evs.forEach(function (n) { window.removeEventListener(n, stop, true); });
    }
    /* a moment later, so the press that started this does not cancel it */
    setTimeout(function () {
      if (id === guardId) evs.forEach(function (n) { window.addEventListener(n, stop, true); });
    }, 250);
    function target() {
      var m, e, r, t;
      if (sErr) {
        t = document.getElementById('fp-ts');
        if (t) return { el: t, k: 'sty' };
      }
      if (fFinErr) {
        m = document.getElementById('fp-fin-msg');
        if (m) return { el: m.previousElementSibling || m, k: 'fin' };
      }
      e = document.querySelector('.fp-xf.has-error');
      r = document.getElementById('fp-xrow') || document.getElementById('fp-pers');
      if (e && r) return { el: r, k: 'xtra' };
      return null;
    }
    function frame() {
      if (id !== guardId) return;
      var now = Date.now();
      if (now - t0 > 6000) { stop(); return; }
      var g = target();
      if (g) {
        if (!lockedAt) lockedAt = now;
        if (now - lockedAt > 2500) { stop(); return; }
        var y = Math.max(0, g.el.getBoundingClientRect().top + window.pageYOffset - 100), d = y - window.pageYOffset;
        if (Math.abs(d) > 2) {
          window.scrollTo({ top: Math.abs(d) < 12 ? y : window.pageYOffset + d * 0.2, behavior: 'instant' });
        } else if (!focused && g.k === 'xtra') {
          focused = true;
          var e2 = document.querySelector('.fp-xf.has-error'), f2 = e2 && e2.querySelector('input[type="text"]:not(.gpo-color),textarea');
          f2 && f2.focus({ preventScroll: true });
        }
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }
  function isAddTarget(t) {
    var b = t && t.closest && t.closest('button,input[type="submit"],[type="submit"]');
    if (!b) return false;
    return b.name === 'add' || b.classList.contains('product-form__submit') || /add to cart/i.test(b.textContent || b.value || '');
  }
  /* the form app swallows the click itself, so listen for the press / release (like the older cart-prompt script does); once per press */
  ['pointerup', 'click', 'touchend', 'keydown'].forEach(function (t) {
    window.addEventListener(t, function (e) {
      if (t === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
      if (!isAddTarget(e.target)) return;
      if (!document.querySelector('.fp-in-panel .fp-chips')) return;
      var n = Date.now();
      if (n - lastAdd < 400) return;
      lastAdd = n;
      /* text style or finish still empty at the press: the form app will refuse the add, so flag it straight away */
      if (styleMissing()) { sFlag = true; try { syncStyleErr(); } catch (err) { /* ignore */ } }
      if (finMissing()) fFlag = true;
      startGuard();
    }, true);
  });

  /* homepage featured product and Custom Map Print (any location) page only: put all the personalising fields (from the "Please provide your map location..." line down to Your Notes) in one box under a single button. The box is open when the page loads; the button says it can be closed (and shows what was entered once it is closed). Nothing is removed or disabled, so the form and the price work exactly as before. When the form app flags a field as required (Add to cart pressed with the map location / text empty), the box opens (if closed) so the customer can see where to fill things in. */
  function syncXtra() {
    var sec = document.querySelector(FEAT);
    if (!sec) return;
    var els = sec.querySelectorAll('.gpo-element'), start = null, i;
    for (i = 0; i < els.length; i++) {
      if (!els[i].querySelector('.gpo-element') && /^please provide your map location/i.test(els[i].textContent.trim())) { start = els[i]; break; }
    }
    var row = document.getElementById('fp-xrow');
    if (!start) { row && row.parentNode.removeChild(row); return; }
    css();
    var list = [], n = start, cnt = 0, j, cb, ins, ta, lab, nm, v, h6, dup, hk;
    var vals = [], extras = [], hs = [];
    while (n) {
      if (n.classList && n.classList.contains('gpo-element')) list.push(n);
      n = n.nextElementSibling;
    }
    /* the small notes the form app puts under the tick options (e.g. the same day dispatch line): first 40 letters of each, to spot the longer repeat of it */
    for (i = 0; i < list.length; i++) {
      ta = list[i].querySelectorAll('.gpo-ov-helptext');
      for (j = 0; j < ta.length; j++) { v = norm(ta[j].textContent).slice(0, 40); if (v.length >= 20) hs.push(v); }
    }
    for (i = 0; i < list.length; i++) {
      cb = list[i].querySelectorAll('input[type="checkbox"]');
      for (j = 0; j < cb.length; j++) {
        if (!cb[j].checked) continue;
        cnt++;
        lab = (cb[j].id && document.querySelector('label[for="' + cb[j].id + '"]')) || cb[j].closest('label');
        nm = lab ? lab.textContent.replace(/\s+/g, ' ').replace(/\s*\(order by[^)]*\)/i, '').replace(/\s*\(/, ' (').trim() : '';
        if (nm) extras.push(nm);
      }
      ins = list[i].querySelectorAll('input[type="text"]:not(.gpo-color)');
      for (j = 0; j < ins.length; j++) {
        v = ins[j].value.trim();
        if (v) { cnt++; vals.push(v); }
      }
      ta = list[i].querySelectorAll('textarea');
      for (j = 0; j < ta.length; j++) {
        if (ta[j].value.trim()) { cnt++; extras.push('Notes added'); }
      }
      /* the box for the text: on the homepage the heading and the box are one block, on the product page the box is the block just after the heading */
      if (ins.length && !list[i].classList.contains('fp-xtxt') && (/text to go over map/i.test(list[i].textContent) || (i > 0 && !list[i - 1].querySelector('input,textarea,select') && /^text to go over map/i.test(list[i - 1].textContent.trim())))) list[i].classList.add('fp-xtxt');
      /* a heading-only block that starts with the same words as one of those notes is the repeat of it: hidden, so the note shows once */
      h6 = list[i].querySelector('.gpo-heading h6');
      hk = h6 ? norm(h6.textContent).slice(0, 40) : '';
      dup = !!(h6 && hk.length >= 20 && !list[i].querySelector('input,textarea,select') && hs.indexOf(hk) > -1);
      list[i].classList.toggle('fp-xdup', dup);
    }
    if (!row) {
      row = document.createElement('button');
      row.type = 'button';
      row.id = 'fp-xrow';
      row.innerHTML = '<span class="fp-xi">' + PEN + '</span><span class="fp-xt"><b></b><span class="fp-xs"></span><span class="fp-xe"></span></span><span class="fp-xn" hidden></span><span class="fp-xc">' + CHEV + '</span>';
      row.addEventListener('click', function () {
        xOpen = !xOpen;
        xNudge = false;
        syncXtra();
      });
    }
    if (row.nextElementSibling !== start) start.parentNode.insertBefore(row, start);
    var bad = null;
    for (i = 0; i < list.length; i++) {
      if (list[i].classList.contains('has-error')) { bad = list[i]; break; }
    }
    if (!bad) {
      xErrShown = false;
      xNudge = false;
    } else if (!xErrShown) {
      /* open the box (if it was closed) and say what to do; the click guard does the scrolling and puts the cursor in the first flagged box */
      xErrShown = true;
      xOpen = true;
      xNudge = true;
    }
    var ttl = row.querySelector('.fp-xt b'), sub = row.querySelector('.fp-xs'), ex = row.querySelector('.fp-xe');
    /* open: say it can be closed; closed: invite to open, or show what has been entered */
    var tt = xOpen ? 'Personalise your print' : (cnt ? 'Your personalisation' : 'Click here to personalise');
    if (ttl.textContent !== tt) ttl.textContent = tt;
    var filled = !xOpen && !xNudge && vals.length > 0;
    var st = xNudge ? 'Fill in the boxes marked below, then add to cart' : (xOpen ? 'Tap here to close once you’ve finished' : (filled ? vals.join(' · ') : 'Your location, text & extras'));
    if (sub.textContent !== st) sub.textContent = st;
    var et = (xNudge || xOpen) ? '' : extras.join(' · ');
    if (ex.textContent !== et) ex.textContent = et;
    if (xNudge) row.setAttribute('data-n', '1'); else row.removeAttribute('data-n');
    if (filled) row.setAttribute('data-f', '1'); else row.removeAttribute('data-f');
    var badge = row.querySelector('.fp-xn'), bt = (cnt && !xOpen) ? cnt + ' added' : '';
    if (badge.textContent !== bt) badge.textContent = bt;
    badge.hidden = !bt;
    row.setAttribute('aria-expanded', xOpen ? 'true' : 'false');
    for (i = 0; i < list.length; i++) {
      list[i].classList.add('fp-xf');
      list[i].classList.toggle('fp-xintro', i === 0);
      list[i].classList.toggle('fp-xh', !xOpen);
    }
  }

  /* The price on the page, in whatever format the market uses (£44.50, $54.95, €54,95, CHF 54.95, 54,95 €, €1.234,56), times the quantity, written back in that same format. Returns null when no price can be read. */
  function money(text, qty) {
    var s = String(text || '').replace(/\s+/g, ' ').trim();
    var m = /\d[\d.,' ]*\d|\d/.exec(s);
    if (!m) return null;
    var tok = m[0].replace(/[ ']/g, '');
    var dm = /^(.*?)([.,])(\d{1,2})$/.exec(tok);
    var whole = (dm ? dm[1] : tok).replace(/[.,]/g, '');
    if (!/^\d+$/.test(whole)) return null;
    var val = parseFloat(whole + (dm ? '.' + dm[3] : ''));
    if (!isFinite(val)) return null;
    val = val * (qty > 0 ? qty : 1);
    var dec = dm ? dm[2] : null, thou = dec === ',' ? '.' : ',';
    var grouped = dm ? /[.,]/.test(dm[1]) : /[.,]/.test(tok);
    var parts = (dec ? val.toFixed(2) : String(Math.round(val))).split('.'), out = parts[0];
    if (grouped || out.length > 3) out = out.replace(/\B(?=(\d{3})+(?!\d))/g, thou);
    if (dec) out += dec + parts[1];
    /* a currency symbol or code before or after the number: a symbol, a 3 letter code such as CHF, or a short name such as kr */
    function cur(t) { return !!t && (/[^A-Za-z]/.test(t) || /^[A-Z]{3}$/.test(t) || /^(kr|zł|Kč|ft|lei|rs)$/i.test(t)); }
    var before = s.slice(0, m.index), after = s.slice(m.index + m[0].length);
    var lead = /([^\s\d.,]{1,4})(\s*)$/.exec(before), trail = /^(\s*)([^\s\d.,]{1,4})(?=\s|$)/.exec(after);
    lead = lead && cur(lead[1]) ? lead : null;
    trail = trail && cur(trail[2]) ? trail : null;
    /* "€54,95 EUR": the symbol leads, so the trailing code is just the page repeating itself */
    if (lead && trail && /^[A-Z]{3}$/.test(trail[2])) trail = null;
    return (lead ? lead[1] + (lead[2] ? ' ' : '') : '') + out + (trail ? (trail[1] ? ' ' : '') + trail[2] : '');
  }

  /* homepage featured product, Custom Map Print (any location) page and normal map listings: the Add to cart button shows the live total, e.g. "Add to cart · £94.00". The price shown on the page already includes the finish, mount and extras (the form app updates it), so this is that price times the quantity. Only the words on the button change, never its size. If the price cannot be read the button just says "Add to cart" rather than show a wrong total. */
  function syncPrice() {
    var sec = document.querySelector(FEAT) || (document.body.classList.contains('fpx-opt') ? document.querySelector('product-info') : null);
    if (!sec) return;
    var b = sec.querySelector('button[name="add"]'), sp = b && b.querySelector('.btn-text > span');
    if (!sp) return;
    var cur = sp.textContent.trim();
    if (!/^add to cart/i.test(cur)) return;
    var pe = sec.querySelector('.product__price .price__regular') || sec.querySelector('.product__price');
    var qi = sec.querySelector('input[name="quantity"]'), qn = Math.max(1, parseInt(qi && qi.value, 10) || 1);
    var p = pe ? money(pe.textContent, qn) : null;
    var t = p ? 'Add to cart · ' + p : 'Add to cart';
    if (cur !== t) sp.textContent = t;
  }

  /* a size change can leave the chosen finish unavailable (e.g. box frame at 14x14): the form drops it, so put the preview back on the default finish and say which finishes this size doesn't offer */
  var FIN_NAMES = { fine: 'Fine Art Print', rolled: 'Premium Rolled Canvas', classic: 'Classic Frame', float: 'Float Framed Canvas', box: 'Premium Box Frame' };
  function finishSel() {
    var l = document.querySelectorAll('.gpo-element select'), i, s;
    for (i = 0; i < l.length; i++) {
      s = l[i];
      if (/print finish/i.test(s.name || '') && (s.offsetParent !== null || s.getClientRects().length)) return s;
    }
    return null;
  }
  function finType(t) {
    t = String(t || '');
    if (/fine art/i.test(t)) return 'fine';
    if (/rolled/i.test(t)) return 'rolled';
    if (/classic/i.test(t)) return 'classic';
    if (/float/i.test(t)) return 'float';
    if (/box/i.test(t)) return 'box';
    return null;
  }
  function syncAvail() {
    var x = window.__fpx, s = finishSel(), ch = document.querySelector('.fp-in-panel .fp-chips');
    if (!x || !x.s || !s || !ch) return;
    var av = {}, n = 0, i, k, first = null;
    for (i = 0; i < s.options.length; i++) {
      if (!s.options[i].value) continue;
      k = finType(s.options[i].value);
      if (k) { if (!av[k]) { av[k] = 1; n++; if (!first) first = k; } }
    }
    if (!n) return;
    if (!s.value && !av[x.s.type]) {
      /* stop the picker's carry-over retry first, otherwise it would copy the new default into the form as if the customer had chosen it */
      var F = window.__fpF;
      if (F) { F.has = 0; F.n = 0; F.k = s.name || s.getAttribute('data-field-name') || ''; }
      x.s.type = av.classic ? 'classic' : (av.fine ? 'fine' : first);
      x.s.mount = false;
    }
    var miss = [], key;
    for (key in FIN_NAMES) if (!av[key]) miss.push(FIN_NAMES[key]);
    var note = document.getElementById('fp-na-note');
    if (!miss.length) { note && note.parentNode.removeChild(note); return; }
    var tx = 'Not available in this size: ' + miss.join(', ') + '.';
    if (!note) {
      note = document.createElement('p');
      note.id = 'fp-na-note';
      note.className = 'fp-na-note';
    }
    if (note.parentNode !== ch.parentNode || note.previousElementSibling !== ch) ch.parentNode.insertBefore(note, ch.nextSibling);
    if (note.textContent !== tx) note.textContent = tx;
  }

  /* pages whose size is a plain drop-down (not the Globo swatches): a Size choice at the top of the Options sheet that drives that drop-down */
  function pageSizeSelect() {
    if (document.querySelector('.globo-swatch-product-detail')) return null;
    var ss = document.querySelectorAll('product-info select'), i;
    for (i = 0; i < ss.length; i++) {
      if (/size of your print/i.test(ss[i].name || '') && ss[i].options.length > 1) return ss[i];
    }
    return null;
  }
  function nsLabel(t) {
    return String(t || '').replace(/^\s*Size\s+/i, '').replace(/\s+Inches/i, '″').replace(/(\d)x(?=\d)/g, '$1×').trim();
  }
  function syncNativeSize(sh) {
    var src = pageSizeSelect(), sec = sh.querySelector('.fp-zsizen');
    if (!src) { sec && sec.parentNode.removeChild(sec); return; }
    if (!sec) {
      sec = document.createElement('div');
      sec.className = 'fp-zsec fp-zsizen';
      sec.innerHTML = '<p class="fp-zh">Size</p><select class="fp-zns" aria-label="Size"></select>';
      sh.insertBefore(sec, sh.firstChild);
      sec.querySelector('select').addEventListener('change', function (e) {
        var s2 = pageSizeSelect(), mine = e.target;
        if (!s2) return;
        s2.selectedIndex = mine.selectedIndex;
        fire(s2, 'input');
        fire(s2, 'change');
        setTimeout(redraw, 700);
        setTimeout(redraw, 1500);
        setTimeout(redraw, 3000);
        setTimeout(syncAll, 300);
      });
    }
    var sel = sec.querySelector('select'), key = Array.prototype.map.call(src.options, function (o) { return o.text; }).join('|');
    if (sel.getAttribute('data-k') !== key) {
      sel.setAttribute('data-k', key);
      sel.innerHTML = '';
      Array.prototype.forEach.call(src.options, function (o) {
        var op = document.createElement('option');
        op.textContent = nsLabel(o.text);
        sel.appendChild(op);
      });
    }
    if (sel.selectedIndex !== src.selectedIndex && document.activeElement !== sel) sel.selectedIndex = src.selectedIndex;
  }

  /* pages where Text Style is a plain drop-down (the homepage featured product): the picker starts on Bold, so keep its preview in step with the drop-down that actually goes in the cart. Only the preview is updated; no event is sent back to the page, because the theme is already rebuilding its options at that moment and a second event made it flip the choice back */
  function syncStyle() {
    var x = window.__fpx;
    if (!x || !x.s) return;
    var ss = document.querySelectorAll('product-info select'), i, s = null;
    for (i = 0; i < ss.length; i++) {
      if (/^options\[\s*text\s*style\s*\]$/i.test(ss[i].name || '')) { s = ss[i]; break; }
    }
    if (!s || s.selectedIndex < 0) return;
    var m = /\b(bold|thin|squashed)\b/i.exec(s.options[s.selectedIndex].text || '');
    if (!m) return;
    var v = m[1].toLowerCase();
    if (x.s.style !== v) {
      x.s.style = v;
      redraw();
    }
  }

  function syncSheet() {
    var z = document.querySelector('.fp-zoom'), sh = z && z.querySelector('.fp-zsheet');
    if (!sh) return;
    css();
    syncNativeSize(sh);
    if (!box()) return;
    var sec = sh.querySelector('.fp-zpers');
    if (!sec) {
      sec = document.createElement('div');
      sec.className = 'fp-zsec fp-zpers';
      sec.innerHTML = '<button type="button" class="fp-pill fp-zpbtn" data-zpers="toggle"></button>' +
        '<div class="fp-zptxt" hidden><input type="text" class="fp-zpin" maxlength="200" autocomplete="off" autocapitalize="characters" enterkeyhint="done" aria-label="Your own text for the print">' +
        '<div class="fp-zplinks"><button type="button" data-zpers="more">More options on the page ›</button><button type="button" data-zpers="off">Remove</button></div></div>';
      var dn = sh.querySelector('.fp-zdone');
      if (dn) sh.insertBefore(sec, dn); else sh.appendChild(sec);
      var inp = sec.querySelector('.fp-zpin');
      inp.addEventListener('input', function () {
        var f = field();
        if (!f) return;
        f.value = inp.value;
        fire(f, 'input');
        fire(f, 'keyup');
        fire(f, 'change');
      });
      inp.addEventListener('focus', function () { setTimeout(sheetEnd, 250); });
      inp.addEventListener('keydown', function (e) {
        e.stopPropagation();
        if (e.key === 'Enter') { e.preventDefault(); inp.blur(); }
      });
    }
    var b = sec.querySelector('.fp-zpbtn'), on = isOn(), txt = on ? '✓ Personalising' : '✎ Personalise the text';
    if (b.textContent !== txt) b.textContent = txt;
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    var tb = sec.querySelector('.fp-zptxt');
    if (tb.hidden === on) tb.hidden = !on;
    var inp2 = sec.querySelector('.fp-zpin'), f2 = field();
    if (f2) {
      var ph = f2.getAttribute('placeholder') || 'Type your words';
      if (inp2.getAttribute('placeholder') !== ph) inp2.setAttribute('placeholder', ph);
      if (document.activeElement !== inp2 && inp2.value !== f2.value) inp2.value = f2.value;
    }
  }

  /* phones: keep the zoomed photo visible in the strip above the Options sheet (desktop floats the sheet over the photo instead) */
  function layout() {
    var z = document.querySelector('.fp-zoom');
    if (!z) return;
    var sc = z.querySelector('.fp-zoom-scroll'), sh = z.querySelector('.fp-zsheet');
    if (!sc) return;
    if (window.innerWidth >= 900) {
      if (sc.style.bottom) { sc.style.bottom = ''; redraw(); }
      return;
    }
    if (sh) {
      if (sh.style.maxHeight !== '56%') sh.style.maxHeight = '56%';
      if (!sh.__fpRO && window.ResizeObserver) {
        sh.__fpRO = 1;
        new ResizeObserver(function () { try { layout(); } catch (err) { /* ignore */ } }).observe(sh);
      }
      var h = Math.round(sh.getBoundingClientRect().height) + 'px';
      if (sc.style.bottom !== h) { sc.style.bottom = h; redraw(); }
    } else if (sc.style.bottom) {
      sc.style.bottom = '';
      redraw();
    }
  }

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-zpers]');
    if (!b) return;
    e.stopPropagation();
    e.preventDefault();
    var act = b.getAttribute('data-zpers');
    if (act === 'toggle') {
      if (isOn()) { turnOff(); } else {
        turnOn();
        setTimeout(function () {
          var i = document.querySelector('.fp-zpin');
          if (i) { sheetEnd(); i.focus({ preventScroll: true }); setTimeout(sheetEnd, 120); }
        }, 200);
      }
    } else if (act === 'off') {
      turnOff();
    } else if (act === 'more') {
      var x = document.querySelector('.fp-zoom-close');
      x && x.click();
      toText(550);
    }
    setTimeout(syncAll, 80);
  }, true);

  /* pinch to zoom in the enlarged preview (touch only): two fingers apart = zoom in (like a tap, centred between the fingers), two fingers together while zoomed in = zoom back out. The pinch is kept away from the older swipe / tap code (it would otherwise count as a swipe to the next picture or a tap). */
  var pPts = {}, pinch = null, pinchEnd = 0, pOwn = false;
  function pScroll(e) { return e.target && e.target.closest && e.target.closest('.fp-zoom-scroll'); }
  function pCount() { return Object.keys(pPts).length; }
  window.addEventListener('pointerdown', function (e) {
    if (e.pointerType === 'mouse' || !pScroll(e)) return;
    pPts[e.pointerId] = { x: e.clientX, y: e.clientY };
    if (pCount() === 2 && !pinch) {
      var k = Object.keys(pPts), a = pPts[k[0]], b = pPts[k[1]];
      pinch = { d: Math.max(1, Math.hypot(a.x - b.x, a.y - b.y)), done: false };
    }
  }, true);
  window.addEventListener('pointermove', function (e) {
    if (!pPts[e.pointerId]) return;
    pPts[e.pointerId] = { x: e.clientX, y: e.clientY };
    if (!pinch) return;
    e.stopPropagation();
    if (pinch.done || pCount() < 2) return;
    var k = Object.keys(pPts), a = pPts[k[0]], b = pPts[k[1]], r = Math.hypot(a.x - b.x, a.y - b.y) / pinch.d;
    var z = document.querySelector('.fp-zoom'), cv = z && z.querySelector('canvas'), zoomed = !!z && z.getAttribute('data-z') === 'zoom';
    if (!cv || z.querySelector('.fp-zsheet')) return;
    if ((!zoomed && r > 1.25) || (zoomed && r < 0.8)) {
      pinch.done = true;
      pOwn = true;
      try { cv.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, clientX: (a.x + b.x) / 2, clientY: (a.y + b.y) / 2 })); } catch (err) { /* ignore */ }
      pOwn = false;
    }
  }, true);
  ['pointerup', 'pointercancel'].forEach(function (t) {
    window.addEventListener(t, function (e) {
      if (!pPts[e.pointerId]) return;
      delete pPts[e.pointerId];
      if (pinch) {
        /* keep the older swipe code from seeing the lift of a pinching finger */
        e.stopPropagation();
        pinchEnd = Date.now();
        if (!pCount()) pinch = null;
      }
    }, true);
  });
  window.addEventListener('click', function (e) {
    if (pOwn || !pScroll(e)) return;
    if (pinch || Date.now() - pinchEnd < 500) { e.stopPropagation(); e.preventDefault(); }
  }, true);

  function syncAll() {
    try { syncOpt(); syncCard(); syncBody(); syncTS(); syncPill(); syncSheet(); layout(); hiRes(); syncStyle(); syncAvail(); syncXtra(); syncStyleErr(); syncFinish(); syncPrice(); } catch (err) { /* never break the page */ }
  }
  css();
  var q = null;
  new MutationObserver(function () {
    if (q) return;
    q = requestAnimationFrame(function () { q = null; syncAll(); });
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('change', function () { setTimeout(syncAll, 30); }, true);
  document.addEventListener('input', function (e) { if (e.target && (e.target.tagName === 'TEXTAREA' || e.target.tagName === 'INPUT')) setTimeout(syncAll, 30); }, true);
  document.addEventListener('gpoRenderCompleted', function () { setTimeout(syncAll, 50); });
  setInterval(function () { try { hiRes(); } catch (err) { /* ignore */ } }, 700);
  /* the form app's required-field flags are class changes it makes itself, and the price changes too; check them on a light timer */
  setInterval(function () { try { syncStyleErr(); syncFinish(); if (document.querySelector(FEAT)) { syncXtra(); syncPrice(); } else if (document.body.classList.contains('fpx-opt')) { syncOpt(); syncCard(); syncTS(); syncPrice(); } } catch (err) { /* ignore */ } }, 300);
  syncAll();
  setTimeout(syncAll, 800);
  setTimeout(syncAll, 2000);
})();
